/* eslint-disable no-undef */
export default () => (typeof window !== 'undefined' ? parseInt(Math.max(
    document.body.scrollWidth,
    document.documentElement.scrollWidth,
    document.body.offsetWidth,
    document.documentElement.offsetWidth,
    document.documentElement.clientWidth,
), 10) : 0);
